import styled from "@emotion/styled";
import { CircularProgress } from "@mui/material";

interface LoadingSpinnerProps {
  message?: string;
  className?: string;
}

export const LoadingSpinner = ({
  message = "Loading...",
  className,
}: LoadingSpinnerProps) => (
  <LoadingContainer className={className}>
    <CircularProgress />
    <LoadingText>{message}</LoadingText>
  </LoadingContainer>
);

const LoadingContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 400px;
  gap: 16px;
`;

const LoadingText = styled.p`
  color: rgba(0, 0, 0, 0.6);
  margin: 0;
`;
